export default {
  SET_MENU_ITEMS (state, items) {
    state.menuItems = items
  }
}